import { FC, useState } from 'react';
import { ApolloQueryResult } from '@apollo/client';
import { Button } from '@chakra-ui/react';

import {
  DataRoomObjectFragment,
  GetProblemFilesQuery,
} from '../../graphql/generated';
import { initialiseTreatyFilter } from '../search-results-toolbar/search-results-toolbar';
import { TreatyFilter } from '../treaty-filter/treaty-filter';

type props = {
  params: {
    treaties: string[];
    problemType: string;
  };
  treaties: DataRoomObjectFragment[];
  refetch: (variables?: {
    cedants?: string[];
  }) => Promise<ApolloQueryResult<GetProblemFilesQuery>>;
  setTreatyParam: (treaties: string[]) => void;
};

export const ProblematicFilesTreatyFilter: FC<props> = ({
  params,
  treaties,
  refetch,
  setTreatyParam,
}) => {
  const [treatyFilter, setTreatyFilter] = useState<string[]>(
    initialiseTreatyFilter(params.treaties, treaties)
  );

  const handleFilter = async (treaties: string[]) => {
    await refetch({
      cedants: treaties,
    });
    setTreatyParam(treaties);
  };

  const handleTreatyFilterChange = (treaty: string) => {
    const updatedtreatyFilter = treatyFilter.includes(treaty)
      ? treatyFilter.filter((x) => x !== treaty)
      : [...treatyFilter, treaty];

    setTreatyFilter(updatedtreatyFilter);
  };

  const handleSelectAllTreaties = () =>
    setTreatyFilter(initialiseTreatyFilter([], treaties));
  const handleClearTreatyFilter = () => setTreatyFilter([]);
  return (
    <>
      <TreatyFilter
        treaties={treaties}
        selectedTreaties={treatyFilter}
        onChange={handleTreatyFilterChange}
        onSelectAll={handleSelectAllTreaties}
        onDeselectAll={handleClearTreatyFilter}
      />
      <Button
        onClick={() => {
          handleFilter(treatyFilter);
        }}
        data-testid="filter-btn"
        colorScheme="blue"
      >
        Filter
      </Button>
    </>
  );
};
